import { render, staticRenderFns } from "./DictionaryList.vue?vue&type=template&id=5205fc8a&scoped=true"
import script from "./DictionaryList.vue?vue&type=script&lang=js"
export * from "./DictionaryList.vue?vue&type=script&lang=js"
import style0 from "./DictionaryList.vue?vue&type=style&index=0&id=5205fc8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5205fc8a",
  null
  
)

export default component.exports